import { ContentAreaModel, EpiImage, EpiPage } from '@api/types';

export const getContentType = (types?: string[]) => {
  return types != null ? types?.at(-1) || '' : '';
};

export const getMainContentType = (types?: string[]) => {
  return types != null ? types?.at(0) || '' : '';
};

export const getPageContentType = (page?: EpiPage) => {
  return getContentType(page?.contentType);
};

/**
 * Get Hash of the Content Area
 */
export const getContentAreaHash = (area?: ContentAreaModel) => {
  if (!area) {
    return '';
  }
  return area.map((x) => x.contentLink?.guidValue).join('|');
};

/**
 * Check if two Content Areas are equal
 * I.e. have the same children hashes
 */
export const isContentAreaEqual = (area1?: ContentAreaModel, area2?: ContentAreaModel) => {
  if (!area1 || !area2) {
    return false;
  }
  return getContentAreaHash(area1) === getContentAreaHash(area2);
};

/**
 * Get URL from ContentImage type
 */
export const getContentImageUrl = (image: EpiImage) => {
  return typeof image === 'string' ? image : image.url;
};

/**
 * Check if object is content area
 */
export const isContentArea = (data: any) => {
  return !!(
    data &&
    typeof data?.find === 'function' &&
    data?.find((x: any) => x?.contentLink && x?.displayOption !== undefined)
  );
};

export const getContentAreaIds = (content: Array<any>) => {
  return content
    ?.filter((x) => !!x)
    .map((x) => x?.contentLink?.id)
    .filter((x) => x !== undefined) as number[];
};

export const getAncestorsWithoutRootPage = (
  links: Array<EpiPage>,
  homePage?: EpiPage
): Array<EpiPage> => {
  const ancestors = links.length > 0 ? links.slice().reverse().slice(1) : [];

  const includeHomePageToAncestors =
    homePage &&
    !ancestors.find((page) => page.contentLink?.guidValue === homePage.contentLink?.guidValue);
  return includeHomePageToAncestors ? [homePage].concat(ancestors) : ancestors;
};

export const ContentTypes = {
  HomePage: 'HomePage',
  ContentPage: 'ContentPage',
  RootContent: 'RootContent',
  Catalog: 'Catalog',
  CatalogContent: 'CatalogContent',
  Node: 'Node',
  Category: 'Category',
  Product: 'Product',
  Variation: 'Variation',
};

const catalogContentType = [
  ContentTypes.RootContent,
  ContentTypes.Catalog,
  ContentTypes.CatalogContent,
  ContentTypes.Node,
  ContentTypes.Category,
  ContentTypes.Product,
  ContentTypes.Variation,
];
export const isCatalogContentType = (contentType?: Array<string>): boolean => {
  return contentType?.some((x) => catalogContentType.includes(x)) ?? false;
};
export const isCategoryContentType = (contentType?: Array<string>): boolean => {
  return contentType?.some((x) => x === ContentTypes.Category) ?? false;
};
